import { DefaultModalProps } from '@frontend/components/mobile';
import { CommonMessage } from '@frontend/lang';
import { AiOutlineAppstore } from 'react-icons/ai';
import { FaXmark } from 'react-icons/fa6';

import ApplicationCard from '../../application/application-card/application-card.component';
import { useMenuRepository } from '../../menu/menu-repository';
import { MobileDragModal } from '../mobile-drag-modal/mobile-drag-modal.component';

const AppSelectModal = (props: DefaultModalProps) => {
    const { applications } = useMenuRepository();

    return (
        <MobileDragModal
            handleClose={props.handleClose}
            show={props.show}>
            <>
                <div className='text-background-surface flex items-center justify-between pb-4'>
                    <div className='flex items-center justify-start gap-2'>
                        <AiOutlineAppstore size={20} />
                        <div className='justify-start text-xl font-semibold'>{CommonMessage.OBJECTS.APPLICATION.PLURAL}</div>
                    </div>

                    <FaXmark
                        onClick={props.handleClose}
                        className='size-5'
                    />
                </div>
                <div className='modal-body h-full overflow-scroll'>
                    <div className='flex flex-col gap-2 overflow-auto pb-4'>
                        {applications.map((app) => (
                            <ApplicationCard
                                application={app}
                                key={app}
                            />
                        ))}
                    </div>
                </div>
            </>
        </MobileDragModal>
    );
};

export default AppSelectModal;
